
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useState } from 'react';
import useActiveGroup from '@/utils/hooks/user/useActiveGroup';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';
// Utils
import useIsGroup from '@/utils/hooks/user/useIsGroup';
import { useProfilesStore } from '@/utils/zustand/providers/profiles-provider';
// Layout
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
import FeedPreview from '@/components/pages/scheduler/feed/FeedPreview';
import MobileViewAccessModal from '@/components/pages/scheduler/restrictAccessModals/MobileViewAccessModal';
import SchedulerAccessRights, { ModalRestrictionPage } from '@/components/pages/scheduler/SchedulerAccessRights';
// Components
import SchedulerHeader from '@/components/pages/scheduler/SchedulerHeader';
import { PageContentWrapper } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper';
const SchedulerFeedViewContent = ({ hasSchedulerPermission }) => {
    const isGroup = useIsGroup();
    const { activeGroup } = useActiveGroup();
    const { activeSocialProfile } = useActiveSocialProfile();
    const [needReloadScheduledPosts, setNeedReloadScheduledPosts] = useState(false);
    return (<>
            <SchedulerHeader isGroup={isGroup} activeGroup={activeGroup} activeSocialProfile={activeSocialProfile} hasSchedulerPermission={hasSchedulerPermission} setNeedReloadScheduledPosts={setNeedReloadScheduledPosts}/>
            <PageContentWrapper>
                <div className="relative z-0 flex h-full flex-1 flex-col overflow-hidden rounded-t-md">
                    <FeedPreview needReloadScheduledPosts={needReloadScheduledPosts} setNeedReloadScheduledPosts={setNeedReloadScheduledPosts}/>
                    <ModalRestrictionPage activeSocialProfile={activeSocialProfile} hasSchedulerPermission={hasSchedulerPermission}/>
                    <MobileViewAccessModal />
                </div>
            </PageContentWrapper>
        </>);
};
const SchedulerIntermediateFeedViewContent = () => {
    const isGroup = useIsGroup();
    const { activeSocialProfile } = useActiveSocialProfile();
    const { activeMultiSelectionProfiles } = useProfilesStore((state) => state);
    if (isGroup ||
        (activeMultiSelectionProfiles?.socialProfileIds?.length > 1 && !activeSocialProfile)) {
        return <SchedulerFeedViewContent hasSchedulerPermission={true}/>;
    }
    return (<SchedulerAccessRights isFullHeight className="h-full !min-h-0 flex-1 lg:!max-h-screen">
            {({ hasSchedulerPermission }) => (<SchedulerFeedViewContent hasSchedulerPermission={hasSchedulerPermission}/>)}
        </SchedulerAccessRights>);
};
const SchedulerFeedView = () => {
    return (<WrapperSwitchLayout noPadding className="px-5 pt-5 sm:px-8 sm:pt-8" bodyWrapperClass="!pb-0">
            <SchedulerIntermediateFeedViewContent />
        </WrapperSwitchLayout>);
};
export default SchedulerFeedView;

    async function __Next_Translate__getStaticProps__19a539ccda3__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/publishing/scheduler/feed-preview',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19a539ccda3__ as getStaticProps }
  